$('#rec_title').hide();

$(window).on('load', function() {
   
    setTimeout(function() {
    	$('.product-reco-hs').css("display", "block");     
    },2000);
 
   
  
  setTimeout(function() {
    	
// 		$('#recently-viewed-hide').css("display", "block"); 
    
//         if (screen.width > 768) {
//                $(".recent_view_center_slick").slick({
//                 dots: true,
//                 infinite: false,
//                 slidesToShow: 4.5,
//                 slidesToScroll: 4,
//                  centerMode: false,
//                  prevArrow: '<button class="btn-arrow arrow-left"><img src="https://cdn.shopify.com/s/files/1/2674/6290/t/23/assets/arrow.png"></button>',
// 				 nextArrow: '<button class="btn-arrow arrow-right"><img src="https://cdn.shopify.com/s/files/1/2674/6290/t/23/assets/arrow.png"></button>',
// 				responsive: [
//                   {
//                   breakpoint: 1025,
//                     settings: {
//                       slidesToShow: 3.5,
//                       slidesToScroll: 2.5,
//                     }
//                   },
//                   {
//                   breakpoint: 991,
//                     settings: {
//                       slidesToShow: 2.5,
//                       slidesToScroll: 2.5,
                      
//                     }
//                   }
//                 ],	
//                });
//            }
//          else {
//            console.log('no slick');
//             $('.customized-slider.center_slick.slider').wrap('<div class="wrapElement">');
//          }
    
//           let  matched = $(".count_item");
//           matched.length;
//           if(matched.length> 0){
//             $('#rec_title').show();
//             console.log('call the recent_view_center_slick');   
//           }
               
    },7000);
  

       setTimeout(function() {
     
         if (screen.width > 768) {
               $(".related_slick").slick({
                dots: true,
                infinite: false,
                slidesToShow: 4.5,
                slidesToScroll: 4,
                 centerMode: false,
                 prevArrow: '<button class="btn-arrow arrow-left"><img src="https://cdn.shopify.com/s/files/1/2674/6290/t/23/assets/arrow.png"></button>',
				 nextArrow: '<button class="btn-arrow arrow-right"><img src="https://cdn.shopify.com/s/files/1/2674/6290/t/23/assets/arrow.png"></button>',
				responsive: [
                  {
                  breakpoint: 1025,
                    settings: {
                      slidesToShow: 3.5,
                      slidesToScroll: 2.5,
                    }
                  },
                  {
                  breakpoint: 991,
                    settings: {
                      slidesToShow: 2.5,
                      slidesToScroll: 2.5,
                      
                    }
                  }
                ],	
               });
           }
         else {
           //console.log('no slick');
            //$('.customized-slider.center_slick.slider').wrap('<div class="wrapElement">');
         }
	 }, 2200);
            
});

